module.exports = __webpack_public_path__ + "static/media/angela.4c771e15.jpg";